//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && typeof component !== 'undefined' && window.Vue) {
      window.Vue.component('PuiButton', component.exports)
    } export default {
  props: {
    size: {
      type: String,
      default: 'mid'
    },
    fab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classer: self => ({
      'size-small': self.size === 'small',
      'size-medium': ['medium', 'mid'].includes(self.size),
      'size-large': ['big', 'large', 'huge'].includes(self.size),
      fab: self.fab
    })
  }
}
